// extracted by css-extract-rspack-plugin
export default {"emptyState":"UaInu","empyIcon":"W8ffW"};